import LineChart from '../../LineChart.js';
import LineChart2 from '../../LineChart2.js';
import CowsService from '@/services/CowsService';
import AlertDetailsService from '../../../services/AlertDetailsService.js';
import UtilsService from "../../../services/UtilsService";
import { AlertTypes } from '../../../constants/alert_types';
import { EventTypes } from '../../../constants/event_types';
import { mapActions, mapState } from 'vuex';

export default {
    name: "TempAccChart",
    props: ['cow_id', 'timeZoneOffsetProp', 'logData'],
    components: {
        LineChart,
        LineChart2
    },
    data() {
        return {
            error: null,
            fromDate: this.$moment().subtract(4, "days").set('hour', 0).set('minute', 0).set('second', 0),
            toDate: this.$moment().add(1, "days").set('hour', 0).set('minute', 0).set('second', 0),
            fromModal: false,
            toModal: false,
            movementDataRaw: [],
            graphStep: '1',
            spikeFiltered: true,
            graph: 'temperature',
            loaded: false,
            dateAutoRange: true,
            temperatureDataCollection: { datasets: [] },
            phDataCollection: { datasets: [] },
            cowPhDataNum: [],
            lastCalvingEventTime: null,
            cowTempData: [],
            cowTempDataNum: [],
            movementDataCollection: {},
            cowChanges: null,
            activityMedianNew: null,
            nights: null,
            timeZoneOffset: null,
            inCelsius: true,
            firstFetchLoaded: false,
            inseminationTime: null,
            activityChartOptions: {
                animation: {
                    duration: 0
                },
                hover: {
                    animationDuration: 0,
                    mode: 'x'
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            id: 'x-axis-0',
                            stacked: true,
                            type: 'time',
                            bounds: 'ticks',
                            offset: true,
                            time: {
                                unit: 'hour',
                                tooltipFormat: 'MMM D. H:mm',
                                displayFormats: {
                                    minute: 'MMM D. H:mm',
                                    hour: 'MMM D. H[h]',
                                    day: 'MMM D.'
                                }
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 20,
                                min: null,
                                max: null,
                            }
                        }
                    ],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            stacked: true,
                            position: 'left',
                            label: 'Raw',
                            ticks: {
                                min: 0
                            },
                            scaleLabel: {
                                display: false,
                                labelString: this.$t('graph.activityLabel'),
                                fontSize: 15
                            }
                        },
                        /** Relative line is currently not used */
                        // {
                        //   id: 'relative',
                        //   display: 'auto',
                        //   position: 'left',
                        //   type: 'linear',
                        //   beginAtZero: false,
                        //   ticks: {
                        //     callback: function (value, index, values) {
                        //       return value * 100 + '%'
                        //     }
                        //   }
                        // },
                        {
                            id: 'alerts',
                            display: false,
                            type: 'linear',
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                max: 5
                            }
                        },
                        {
                            id: 'heat',
                            type: 'linear',
                            display: false,
                            position: 'right',
                            ticks: {
                                min: -1,
                                max: 3
                            },
                            scaleLabel: {
                                display: false,
                                labelString: this.$t('graph.activityMedian9Scale'),
                                fontSize: 15
                            }
                        },
                        {
                            id: 'pred',
                            display: true,
                            position: 'right',
                            ticks: {
                                min: -0.2,
                                max: 1.2,
                                callback: function(value) {
                                    return UtilsService.formatPercentage(value, 0);
                                }
                            },
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.$t('graph.heatAIPred'),
                                fontSize: 15
                            }
                        },
                    ],
                },
                annotation: {
                    events: ['mouseover', 'mouseout'],
                    annotations: [
                        // {
                        //     drawTime: 'afterDraw',
                        //     id: 'verticalLine',
                        //     type: 'line',
                        //     mode: 'index',
                        //     scaleID: 'x-axis-0',
                        //     value: this.$moment().toISOString(),
                        //     borderColor: 'black',
                        //     borderWidth: 2,
                        // },
                        {
                            drawTime: 'afterDatasetsDraw',
                            id: 'hline',
                            type: 'line',
                            mode: 'horizontal',
                            scaleID: 'y-axis-0',
                            value: null,
                            borderColor: 'grey',
                            borderWidth: 4,
                            label: {
                                enabled: false,
                                content: null
                            },
                            onMouseover: function (e) {
                                this.options.label.enabled = true;
                                this.chartInstance.update();
                            },
                            onMouseout: function (e) {
                                this.options.label.enabled = false;
                                this.chartInstance.update();
                            }
                        },
                    ]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            // Format as percentage for prediction datasets
                            if (data.datasets[tooltipItem.datasetIndex].yAxisID === 'pred') {
                                return data.datasets[tooltipItem.datasetIndex].label + ': ' + 
                                    UtilsService.formatPercentage(tooltipItem.yLabel, 0);
                            }
                            // if the dataset is relative average format tooltip as %
                            if (
                                data.datasets[tooltipItem.datasetIndex].label === 'Relative'
                            ) {
                                return (
                                    'Relative: ' +
                                    Number(tooltipItem.yLabel * 100).toPrecision(3) +
                                    '%'
                                );
                            } else if (
                                data.datasets[tooltipItem.datasetIndex].label === 'Alerts'
                            ) {
                                return data.datasets[tooltipItem.datasetIndex].data[
                                    tooltipItem.index
                                ].label;
                            } else {
                                return (
                                    data.datasets[tooltipItem.datasetIndex].label +
                                    ': ' +
                                    Number(tooltipItem.yLabel).toPrecision(3)
                                );
                            }
                        }
                    }
                }
            },
            temperatureChartOptions: {
                animation: {
                    duration: 0
                },
                hover: {
                    animationDuration: 0,
                    mode: 'x'
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            distribution: 'linear',
                            type: 'time',
                            time: {
                                unit: 'hour',
                                // tooltipFormat: 'lll',
                                displayFormats: {
                                    minute: 'MMM D. H:mm',
                                    hour: 'MMM D. H[h]',
                                    day: 'MMM D.'
                                }
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 20,
                                min: null,
                                max: null,
                            }
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                min: 32,
                                max: 45
                            }
                        },
                        {
                            id: 'calvingPred',
                            display: true,
                            position: 'right',
                            ticks: {
                                min: -0.2,
                                max: 1.2,
                                callback: function(value) {
                                    return UtilsService.formatPercentage(value, 0);
                                }
                            },
                            gridLines: {
                                display: false,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.$t('graph.calvingAIPred'),
                                fontSize: 15
                            }
                        }
                    ],
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            // Format as percentage for prediction datasets
                            if (data.datasets[tooltipItem.datasetIndex].yAxisID === 'calvingPred') {
                                return data.datasets[tooltipItem.datasetIndex].label + ': ' + 
                                    UtilsService.formatPercentage(tooltipItem.yLabel, 0);
                            }
                        }
                    }
                },
                // background colors for different value ranges
                annotation: {
                    annotations: [
                        // {
                        //     drawTime: 'afterDraw',
                        //     id: 'verticalLine',
                        //     type: 'line',
                        //     mode: 'index',
                        //     scaleID: 'x-axis-0',
                        //     value: this.$moment().toISOString(),
                        //     borderColor: 'black',
                        //     borderWidth: 2,
                        //     label:{
                        //         enabled: true,
                        //         content: this.$moment().format('HH:mm'),
                        //         yAdjust: -100,
                        //     },
                        // },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMax: 37,
                            backgroundColor: 'rgba(0, 24, 102, 0.25)',
                            borderWidth: 1,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 37,
                            yMax: 39,
                            backgroundColor: 'rgba(0, 27, 220, 0.25)',
                            borderWidth: 2,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 39,
                            yMax: 41,
                            backgroundColor: 'rgba(0, 206, 95, 0.25)',
                            borderWidth: 2,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 41,
                            yMax: 41.5,
                            backgroundColor: 'rgba(156, 187, 0, 0.25)',
                            borderWidth: 2,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 41.5,
                            backgroundColor: 'rgba(161, 0, 7, 0.15)',
                            borderWidth: 1,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                    ]
                }
            },
            phChartOptions: {
                animation: {
                    duration: 0
                },
                hover: {
                    animationDuration: 0
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            distribution: 'linear',
                            type: 'time',
                            time: {
                                unit: 'hour',
                                // tooltipFormat: 'lll',
                                displayFormats: {
                                    minute: 'MMM D. H:mm',
                                    hour: 'MMM D. H[h]',
                                    day: 'MMM D.'
                                }
                            },
                            ticks: {
                                autoSkip: true,
                                maxTicksLimit: 20,
                                min: null,
                                max: null,
                            }
                        }
                    ],
                    yAxes: [
                        {
                            ticks: {
                                min: 5,
                                max: 8
                            }
                        }
                    ],
                },
                // background colors for different value ranges
                annotation: {
                    annotations: [
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMax: 5.8,
                            backgroundColor: 'rgba(161, 0, 7, 0.15)',
                            borderWidth: 1,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 5.8,
                            yMax: 7,
                            backgroundColor: 'rgba(0, 206, 95, 0.25)',
                            borderWidth: 2,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        },
                        {
                            drawTime: 'beforeDatasetsDraw',
                            type: 'box',
                            mode: 'horizontal',
                            yScaleID: 'y-axis-0',
                            yMin: 7,
                            backgroundColor: 'rgba(0, 24, 102, 0.25)',
                            borderWidth: 1,
                            borderColor: 'rgba(0, 0, 0, 0)'
                        }
                    ]
                }
            },
            haveActivityData: false,
            haveValidActivityData: false,
            haveTempData: false,
            haveValidTempData: false,
            lastTempCount: null
        };
    },
    async mounted() {
        try{
            this.setCelsiusSetting();
            this.getCowTimezone();
            // this.loadTempData();
            await this.fetchData();
        } catch (err) {
            this.error = err.response;
            console.log(err);
        }
    },
    methods: {
        ...mapActions(['fetchAndSetUserCelsius']),
        async setCelsiusSetting() {
            if (this.user.celsius == undefined && this.token) {
                await this.fetchAndSetUserCelsius();
            }
            this.inCelsius = this.user.celsius;
        },
        getCowTimezone() {
            this.timeZoneOffset =
                this.timeZoneOffsetProp || 0
        },
        async loadTempData() {
            switch (this.lastTempCount) {
                case 3:
                    this.graphStep = '0.5';
                    break;
                case 6:
                    this.graphStep = '1';
                    break;
                case 9:
                case 12:
                    this.graphStep = '2';
                    break;
                default:
                    this.graphStep = '0.5';
                    break;
            }
        },
        async resetData() {
            this.haveActivityData = false;
            this.haveValidActivityData = false;
            this.haveTempData = false;
            this.haveValidTempData = false;
        },
        async fetchData(fromDate, toDate) {
            if (fromDate)
                this.fromDate = this.$moment(fromDate);
            if (toDate)
                this.toDate = this.$moment(toDate);

            this.loaded = false;

            const searchFrom = this.$moment(this.fromDate);
            const searchTo = this.$moment(this.toDate);

            let tempFromDate = searchFrom.format();
            let tempToDate = searchTo.format();

            const [
                cowMovementData,
                cowTempData,
                cowPhData,
                relativeAcc,
                activityMedianNew,
                heatDetails,
                calvingDetails
            ] = await Promise.all([
                CowsService.latestAccData(this.cow_id, tempFromDate, tempToDate),
                CowsService.latestTempData(this.cow_id, tempFromDate, tempToDate),
                CowsService.latestPhData(this.cow_id, tempFromDate, tempToDate),
                CowsService.getRelativeAccData(
                    this.cow_id,
                    tempFromDate,
                    tempToDate
                ),
                CowsService.getActivityMedian(this.cow_id,
                    {
                        from_date: tempFromDate,
                        to_date: tempToDate,
                        graph_step: this.graphStep,
                        median_scale: 9,
                        spike_filtered: !this.spikeFiltered
                    }
                ),
                AlertDetailsService.getAlertDetails(this.cow_id,
                    {
                        from_date: tempFromDate,
                        to_date: tempToDate,
                        alert_type: "Heat",
                        value_type: "Heat AI Pred",
                        with_thresholds: true
                    }
                ),
                AlertDetailsService.getAlertDetails(this.cow_id,
                    {
                        from_date: tempFromDate,
                        to_date: tempToDate,
                        alert_type: "Calving",
                        value_type: "Calving AI Pred",
                    }
                ),
            ]);

            this.movementDataRaw = cowMovementData.data;
            this.cowChanges = this.logData;
            this.relativeAcc = relativeAcc.data.relativeActivity;
            this.lastTempCount = relativeAcc.data.lastTempCount;
            this.cowTempData = cowTempData.data;

            this.cowPhDataNum = cowPhData.data.ph.map((x) => {
                return { x: x.time, y: x.ph ? (Math.round(x.ph * 100) / 100) : 0 };
            });

            this.cowTempDataNum = this.cowTempData.temp.map((x) => {
                var temp = this.inCelsius ? x.temp : this.toFahrenheit(x.temp);

                return {
                    x: x.time,
                    y: temp
                };
            });

            this.activityMedianNew =
                (activityMedianNew && activityMedianNew.data) ||
                [];

            this.heatDetails = heatDetails && heatDetails.data['alert_details'] || [];
            this.calvingDetails = calvingDetails && calvingDetails.data['alert_details'] || [];

            this.cowChanges.forEach(change => {
                // Check if the change is an insemination event and if it is within the last 6 months
                if (change.nameOfAction === "Calving" && this.$moment(change.date).isAfter(this.$moment().subtract(6, 'months'))) {
                    this.lastCalvingEventTime = change.date;
                }
            });

            if(this.lastCalvingEventTime){
                this.calvingDetails = this.calvingDetails.filter(detail => this.$moment(detail.time).isBefore(this.$moment(this.lastCalvingEventTime)));
            }

            this.haveActivityData = this.movementDataRaw && (Object.values(this.movementDataRaw).reduce((a, b) => a + b.length, 0) > 0);
            this.haveTempData = this.cowTempData && this.cowTempData.temp && this.cowTempData.temp.length > 0;

            this.fromDate = searchFrom
            this.toDate = searchTo

            this.firstFetchLoaded = true;
            
            await this.$nextTick(); // Ensure Vue updates before filling data
            this.fillData();
        },
        fillData(fromDate, toDate) {
            try {
                if (fromDate)
                    this.fromDate = this.$moment(fromDate);
                if (toDate)
                    this.toDate = this.$moment(toDate);

                // Check for valid activity data
                this.haveValidActivityData = false;
                if (this.haveActivityData)
                    for (let i = 0; i < this.movementDataRaw.highActivity.length; i++) {
                        const v = [
                            this.movementDataRaw.highActivity[i].accData,
                            this.movementDataRaw.veryHighActivity[i].accData,
                            this.movementDataRaw.lowActivity[i].accData
                        ].reduce((a, b) => a + b, 0);
                        if (v > 0) {
                            this.haveValidActivityData = true;
                            break;
                        }
                    }

                // Check for valid temperature data
                this.haveValidTempData = false;
                if (this.haveTempData)
                    for (let i = 0; i < this.cowTempData.temp.length; i++) {
                        if (this.cowTempData.temp[i].temp >= 32 && this.cowTempData.temp[i].temp <= 45) {
                            this.haveValidTempData = true;
                            break;
                        }
                    }

                this.movementDataCollection = this.customGraphStep();
                /** Relative line is currently not used */
                // this.movementDataCollection.datasets.push({
                //   label: 'Relative',
                //   type: 'line',
                //   yAxisID: 'relative',
                //   fill: false,
                //   data: this.relativeAcc.map((x, i) => { return {x: x.time, y: x.accData, test: 'test'} })
                // })

                this.cowChanges = this.cowChanges.filter(change => {
                    return (
                        (change.type === AlertTypes.Heat || change.type === AlertTypes.RepeatHeat ||
                            change.status !== 'dismissed') && change.status !== 'hidden'
                    );
                });

                this.activityChartOptions.annotation.annotations = this.activityChartOptions.annotation.annotations.filter(
                    a => a.class !== 'heat-window'
                );

                // Add heat window to chart
                this.cowChanges.forEach(change => {
                    if (
                        (change.type === AlertTypes.Heat || change.type === AlertTypes.RepeatHeat) &&
                        (change.status === 'confirmed' || change.status === 'active')
                    ) {
                        if (change.date) {

                            let date = this.$moment(change.dateToDisplay, "DD MMM YYYY HH:mm")

                            this.activityChartOptions.annotation.annotations.push(
                                {
                                    class: 'heat-window',
                                    drawTime: 'afterDatasetsDraw',
                                    type: 'box',
                                    mode: 'horizontal',
                                    xScaleID: 'x-axis-0',
                                    xMin: this.$moment(date).toISOString(),
                                    xMax: this.$moment(date).add(6, 'hours').toISOString(),
                                    backgroundColor: 'rgba(255, 255, 102, 0.3)',
                                    borderWidth: 1,
                                    borderColor: 'rgba(0, 0, 0, 0)'
                                },
                                {
                                    class: 'heat-window',
                                    drawTime: 'afterDatasetsDraw',
                                    type: 'box',
                                    mode: 'horizontal',
                                    xScaleID: 'x-axis-0',
                                    xMin: this.$moment(date).add(6, 'hours').toISOString(),
                                    xMax: this.$moment(date).add(13, 'hours').toISOString(),
                                    backgroundColor: 'rgba(128, 255, 128, 0.3)',
                                    borderWidth: 1,
                                    borderColor: 'rgba(0, 0, 0, 0)'
                                },
                                {
                                    class: 'heat-window',
                                    drawTime: 'afterDatasetsDraw',
                                    type: 'box',
                                    mode: 'horizontal',
                                    xScaleID: 'x-axis-0',
                                    xMin: this.$moment(date).add(13, 'hours').toISOString(),
                                    xMax: this.$moment(date).add(16, 'hours').toISOString(),
                                    backgroundColor: 'rgba(78, 198, 78, 0.3)',
                                    borderWidth: 1,
                                    borderColor: 'rgba(0, 0, 0, 0)'
                                },
                                {
                                    class: 'heat-window',
                                    drawTime: 'afterDatasetsDraw',
                                    type: 'box',
                                    mode: 'horizontal',
                                    xScaleID: 'x-axis-0',
                                    xMin: this.$moment(date).add(16, 'hours').toISOString(),
                                    xMax: this.$moment(date).add(20, 'hours').toISOString(),
                                    backgroundColor: 'rgba(255, 173, 153, 0.3)',
                                    borderWidth: 1,
                                    borderColor: 'rgba(0, 0, 0, 0)'
                                }
                            );
                        }
                    }
                });

                // works from Cow logs table
                this.movementDataCollection.datasets.push({
                    label: 'Alerts',
                    type: 'scatter',
                    yAxisID: 'alerts',
                    pointRadius: 10,
                    borderColor: 'rgba(0, 0, 0, 0)',
                    pointStyle: this.cowChanges.map(change => {
                        let img = new Image(25, 25);
                        switch (change.type) {
                            // Events
                            case EventTypes.Insemination:
                                img.src = require('@/assets/icons/chart/insemination.svg');
                                return img;
                            case EventTypes.Pregnant:
                                img.src = require('@/assets/icons/chart/pregnancy_check.svg');
                                return img;
                            case EventTypes.DryingOff:
                                img.src = require('@/assets/icons/chart/drying_off.svg');
                                return img;
                            case EventTypes.Note:
                            case EventTypes.MoveToRepro:
                            case EventTypes.MoveToVWP:
                                img.src = require('@/assets/icons/chart/list.svg');
                                return img;
                            case EventTypes.Culled:
                                img.src = require('@/assets/icons/chart/culled.svg');
                                return img;
                            // Alerts
                            case AlertTypes.RepeatHeat:
                            case AlertTypes.Heat:
                                if (change.status === 'dismissed') {
                                    img.src = require('@/assets/icons/chart/heat-dismiss.svg');
                                    return img;
                                }
                                img.src = require('@/assets/icons/chart/heat.svg');
                                return img;
                            // case AlertTypes.PossibleMilkFever:
                            case AlertTypes.HighTemp:
                                img.src = require('@/assets/icons/chart/fever.svg');
                                return img;
                            case AlertTypes.LowTemp:
                                img.src = require('@/assets/icons/chart/low_temp.svg');
                                return img;

                            case AlertTypes.LowWaterIntake:
                                img.src = require('@/assets/icons/chart/few_water_intake.svg');
                                return img;
                            case AlertTypes.IncreasedActivity:
                                img.src = require('@/assets/icons/chart/increased_activity.svg');
                                return img;
                            case AlertTypes.DecreasedActivity:
                                img.src = require('@/assets/icons/chart/decreased_activity.svg');
                                return img;

                            // Technical Alerts
                            case AlertTypes.OutOfRange:
                            case AlertTypes.LowCoverage:
                            case AlertTypes.NetworkFailure:
                                img.src = require('@/assets/icons/chart/error.svg');
                                return img;

                            // Default
                            case AlertTypes.Calving:
                            default:
                                img.src = require('@/assets/icons/alert.svg');
                                return img;
                        }
                    }),
                    hoverRadius: 22,
                    fill: false,
                    data: this.cowChanges.map((data) => {
                        
                        let date = data.dateToDisplay ? this.$moment(data.dateToDisplay, "DD MMM YYYY HH:mm") : null;

                        return {
                            x: date,
                            y: [
                                AlertTypes.OutOfRange,
                                AlertTypes.LowCoverage,
                                AlertTypes.NetworkFailure
                            ].includes(data.type)
                                ? 3.8
                                : 4.5, // tech alerts moved on y axis
                            label: data.nameOfAction
                        };
                    })
                });

                const calvingDetails = this.processGaps(this.calvingDetails);

                this.calvingPreds = calvingDetails.map((x)=>{
                    return {
                        x: x.time || x.x,
                        y: x.value || x.y
                    }
                })

                this.calvingLimits = calvingDetails.map((x)=>{
                    return {
                        x: x.x || x.time,
                        y: x.limit || x.y
                    }
                })

                this.temperatureDataCollection = {
                    datasets: [
                        {
                            label: this.$t('graph.temperatureData'),
                            data: this.cowTempDataNum,
                            backgroundColor: 'rgba(17,62,83,0.3)',
                            fill: 'false',
                            lineTension: 0
                        },
                        { 
                            data: this.calvingPreds,
                            type: 'line',
                            label: this.$t('graph.calvingAIPred'),
                            borderColor: '#FF6D34',
                            yAxisID: 'calvingPred',
                            spanGaps: false,
                            fill: false,
                            order: -1,
                            radius: 2
                        },
                        {
                            data: this.calvingLimits, 
                            type: 'line',
                            label: this.$t('graph.calvingAILimit'),
                            backgroundColor: '#ffffff',
                            borderColor: '#FF6D34',
                            borderDash: [10, 10],
                            yAxisID: 'calvingPred',
                            fill: false,
                            order: -1,
                            spanGaps: false,
                            pointRadius: 0
                        }
                    ]
                };

                this.phDataCollection = {
                    datasets: [
                        {
                            label: this.$t('graph.phValues'),
                            data: this.cowPhDataNum,
                            backgroundColor: 'rgba(255,69,0,0.3)',
                            fill: 'false',
                            lineTension: 0
                        },
                    ]
                };

                // use modified min/max so that the data fits in the chart area
                const chartTicks = [
                    this.activityChartOptions.scales.xAxes[0].ticks,
                    this.temperatureChartOptions.scales.xAxes[0].ticks,
                    this.phChartOptions.scales.xAxes[0].ticks
                ];

                this.temperatureChartOptions.scales.yAxes[0].ticks.min = this.inCelsius ? 32 : 89.6;
                this.temperatureChartOptions.scales.yAxes[0].ticks.max = this.inCelsius ? 45 : 113;

                this.temperatureChartOptions.annotation.annotations[0].yMax = this.inCelsius ? 37 : this.toFahrenheit(37);

                this.temperatureChartOptions.annotation.annotations[1].yMin = this.inCelsius ? 37 : this.toFahrenheit(37);
                this.temperatureChartOptions.annotation.annotations[1].yMax = this.inCelsius ? 39 : this.toFahrenheit(39);

                this.temperatureChartOptions.annotation.annotations[2].yMin = this.inCelsius ? 39 : this.toFahrenheit(39);
                this.temperatureChartOptions.annotation.annotations[2].yMax = this.inCelsius ? 41 : this.toFahrenheit(41);

                this.temperatureChartOptions.annotation.annotations[3].yMin = this.inCelsius ? 41 : this.toFahrenheit(41);
                this.temperatureChartOptions.annotation.annotations[3].yMax = this.inCelsius ? 41.5 : this.toFahrenheit(41.5);

                this.temperatureChartOptions.annotation.annotations[4].yMin = this.inCelsius ? 41.5 : this.toFahrenheit(41.5);

                chartTicks.forEach((ticks) => {
                    ticks.min = this.$moment(this.fromDate).utcOffset(this.timeZoneOffset);
                    ticks.max = this.$moment(this.toDate).utcOffset(this.timeZoneOffset);
                })

                const boxes = this.createDayNightAnnotations();
                const chartAnnotations = [
                    this.activityChartOptions.annotation,
                    this.temperatureChartOptions.annotation,
                    this.phChartOptions.annotation
                ];
                chartAnnotations.forEach((annotation) => {
                    annotation.annotations = annotation.annotations
                        .filter(a => a.class !== 'day-night')
                        .concat(boxes)
                })

                this.loaded = true;

            } catch (err) {
                this.error = err.response;
                console.log(err);
            } finally {
                this.loaded = true;
            }
        },
        toFahrenheit(temp) {
            return (temp * (9 / 5)) + 32
        },
        async updateDateFilterOnStepChange() {
            if (this.dateAutoRange) {
                this.fromDate = this.$moment(this.toDate).add(-this.graphStep*4, "days")
                await this.fetchData();
            }
        },
        stepDateFilters(direction) {
            // Use moment.js to step forward or backward in the date range
            const diff = this.$moment(this.toDate).diff(this.$moment(this.fromDate));

            if (direction === 'back') {
                this.fromDate = this.$moment(this.fromDate).subtract(diff, 'milliseconds');
                this.toDate = this.$moment(this.toDate).subtract(diff, 'milliseconds');
            } else if (direction === 'forward') {
                this.fromDate = this.$moment(this.fromDate).add(diff, 'milliseconds');
                this.toDate = this.$moment(this.toDate).add(diff, 'milliseconds');
            }

            this.fetchData();
        },
        customGraphStep() {
            // if no step is selected don't do anything
            if (this.graphStep === '') return { datasets: [] };
            // copy global vars so we dont have to request them every time
            const dateFns = this.dateFns;
            // let movementDataRawTemp = this.movementDataRaw;
            // let activityMedianNew = this.activityMedianNew;

            // make the collection ready for our data
            let movementDataCollection = {
                datasets: [
                    {
                        label: this.$t('graph.lowActivity'),
                        data: [],
                        backgroundColor: '#6A7C9B'
                    },
                    {
                        label: this.$t('graph.highActivity'),
                        data: [],
                        backgroundColor: '#113E52'
                    },
                    {
                        label: this.$t('graph.veryHighActivity'),
                        data: [],
                        backgroundColor: '#FF6C34'
                    },
                    {
                        type: 'line',
                        label: this.$t('graph.activityMedian9Scale'),
                        data: [],
                        borderColor: '#F08080',
                        yAxisID: 'heat',
                        fill: false,
                        order: -1,
                        radius: 2
                    },
                    {
                        type: 'line',
                        label: this.$t('graph.heatAIPred'),
                        data: [],
                        borderColor: '#0000FF',
                        yAxisID: 'pred',
                        fill: false,
                        order: -1,
                        radius: 2
                    },
                    {
                        type: 'line',
                        label: this.$t('graph.heatAILimit'),
                        borderColor: '#0000FF',
                        borderDash: [10, 10],
                        yAxisID: 'pred',
                        fill: false,
                        order: -1,
                        spanGaps: false,
                        pointRadius: 0,
                    }
                ]
            };
            const graphStep = parseFloat(this.graphStep) * 60;
            // the datasets needs to be in the same order as the collection above
            const datasets = [
                {
                    data: this.movementDataRaw.lowActivity,
                    dataKey: 'accData',
                    timeKey: 'time'
                },
                {
                    data: this.movementDataRaw.highActivity,
                    dataKey: 'accData',
                    timeKey: 'time'
                },
                {
                    data: this.movementDataRaw.veryHighActivity,
                    dataKey: 'accData',
                    timeKey: 'time'
                },
                { data: this.activityMedianNew, dataKey: 'median', timeKey: 'timestamp' },
            ];
            datasets.forEach((dataset, index) => {
                if (!dataset.data || dataset.data.length === 0) return;
                // array for dedupe
                let dates = [];
                let rounded;
                // every activity group has the same amount of data so we can loop over them at the same time
                for (let i = 0; i < dataset.data.length; i++) {
                    let date = this.$moment(dataset.data[i][dataset.timeKey]);
                    date = dateFns.setSeconds(date, 0);
                    date = dateFns.setMilliseconds(date, 0);
                    // for half an hour or hour we can use the same logic: zero out seconds milliseconds, round to 30 or 60
                    if (graphStep === 30 || graphStep === 60) {
                        rounded = dateFns.setMinutes(
                            date,
                            Math.round(dateFns.getMinutes(date) / graphStep) * graphStep
                        );
                    } else if (
                        [120, 360, 720, 1440].includes(graphStep)
                    ) {
                        date = dateFns.setMinutes(date, 0);
                        rounded = new Date(
                            date.setUTCHours(
                                Math.round(date.getUTCHours() / (graphStep / 60)) *
                                (graphStep / 60)
                            )
                        );
                    }
                    if (!dates.length || !dateFns.isEqual(dates[dates.length - 1], rounded)) {
                        dates.push(rounded);
                        movementDataCollection.datasets[index].data.push({
                            t: rounded.toISOString(),
                            y: dataset.data[i][dataset.dataKey] || 0
                        });
                    } else {
                        movementDataCollection.datasets[index].data[dates.length - 1].y +=
                            dataset.data[i][dataset.dataKey] || 0;
                    }
                }
            });

            // Process heat predictions WITHOUT aggregation
            if (this.heatDetails && this.heatDetails.length > 0) {
                // Use heat details directly without sorting since they're already in order
                const heatDetails = this.processGaps(this.heatDetails);

                const valueDataset = heatDetails.map(detail => {
                    return {
                        t: this.$moment(detail.time).toISOString(),
                        y: detail.value
                    }
                });
                
                const limitDataset = heatDetails.map(detail => {
                    // Before June 2025, set limit to 0.6, because that is where
                    // we started saving the limit values
                    if (this.$moment(detail.time).isBefore('2025-07-01') && detail.limit === null) {
                        return {
                            t: this.$moment(detail.time).toISOString(),
                            y: 0.6
                        };
                    }
                    return {
                        t: this.$moment(detail.time).toISOString(),
                        y: detail.limit
                    };
                });

                // Assign processed datasets
                movementDataCollection.datasets[4].data = valueDataset;
                movementDataCollection.datasets[5].data = limitDataset;
            }

            return movementDataCollection;
        },
        processGaps(data) {
            let newData = [];

            if (!data || data.length === 0) return newData;

            // Process all points except the last one to check for gaps
            for (let i = 0; i < data.length - 1; i++) {
                newData.push({
                    time: data[i].time,
                    value: data[i].value,
                    limit: data[i].limit
                })

                // Check for gap > 1.5 hours
                const currentTime = this.$moment(data[i].time);
                const nextTime = this.$moment(data[i+1].time);
                const diffHours = nextTime.diff(currentTime, 'hours', true);

                if (diffHours > 1.5) {
                    // Calculate middle point time between current and next
                    const middleTime = this.$moment(currentTime).add(diffHours/2, 'hours');

                    // Add null points to create a gap in both datasets
                    // Null values won't be connected in the chart
                    // (Necessary, because if there are log gaps, the chart would connect them)
                    // See: spanGaps false setting in the chart options
                    newData.push({
                        time: middleTime.toISOString(),
                        value: null,
                        limit: null,
                    });
                }
            }

            // Add the last point
            if (data.length > 0) {
                const lastPoint = data[data.length - 1];
                newData.push({
                    time: lastPoint.time,
                    value: lastPoint.value,
                    limit: lastPoint.limit
                });
            }

            return newData;
        },
        createDayNightAnnotations() {
            if (this.graphStep > 6) return [];
            let boxes = [];
            let template = {
                class: 'day-night',
                drawTime: 'beforeDatasetsDraw',
                type: 'box',
                mode: 'horizontal',
                xScaleID: 'x-axis-0',
                xMin: null,
                xMax: null,
                backgroundColor: 'rgba(50,50,50,.1)',
                borderWidth: 1,
                borderColor: 'rgba(0, 0, 0, 0)'
            };
            let from = this.$moment(this.fromDate);
            const to = this.$moment(this.toDate);

            // get starting date
            const hours = from.hours();
            if (hours < 6 && hours >= 0) {
                template.xMin = from.toISOString();
                template.xMax = from.hours(6).toISOString();
            } else if (hours > 6 && hours < 18) {
                template.xMin = from.hours(18).toISOString();
                template.xMax = from
                    .add(1, 'days')
                    .hours(6)
                    .toISOString();
            } else {
                template.xMin = from.toISOString();
                template.xMax = from
                    .add(1, 'days')
                    .hours(6)
                    .toISOString();
            }
            boxes.push(JSON.parse(JSON.stringify(template))); // push in a copy of template

            // set up time of days then keep adding days until we reach target date
            template.xMin = this.$moment(template.xMin)
                .hours(18)
                .add(-1, 'days')
                .toISOString();
            while (this.$moment(template.xMax).isBefore(to)) {
                template.xMin = this.$moment(template.xMin)
                    .add(1, 'days')
                    .toISOString();
                template.xMax = this.$moment(template.xMax)
                    .add(1, 'days')
                    .toISOString();
                boxes.push(JSON.parse(JSON.stringify(template))); // push in a copy of template
            }
            return boxes;
        }
    },
    computed: {
        formattedFromDate() {
            return this.fromDate
                ? this.$moment(this.fromDate).format('DD-MM-YYYY')
                : '';
        },
        formattedToDate() {
            return this.toDate ? this.$moment(this.toDate).format('DD-MM-YYYY') : '';
        },
        ...mapState(['user', 'token'])
    },
    watch: {
        offset: function (newValue, oldValue) {
            this.getAccData(newValue);
        },
        graphStep: function () {
            this.updateDateFilterOnStepChange();
            this.movementDataCollection = this.customGraphStep();
        },
        '$store.state.cows.cow': async function(newValue) {
            try {
                this.error = null;
                if (newValue) {
                    this.inseminationTime = newValue.last_insemination;
                    
                    if(this.firstFetchLoaded){
                        this.loadTempData();
                        this.fillData(this.fromDate, this.toDate);
                    }
                }
            } catch (err) {
                this.error = err.response;
                console.log(err);
            }
        },
        cow_id: async function () {
            this.loadTempData();
            await this.fetchData();
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/_cow-profile/temp-acc-chart/temp-acc-chart.js